import { ISelectItem } from '@lla-platform/core/core-ui'

export enum DailyAverageMetric {
  Sales = 'Sales',
  CarCount = 'CarCount',
  AverageTicket = 'AverageTicket'
}

export const DailyAverageMetricToLabel: { [key: string]: string } = {
  Sales: 'Sales',
  CarCount: 'Car Count',
  AverageTicket: 'Average Ticket'
}

export const DailyAverageMetricItems: ISelectItem[] = [
  {
    label: DailyAverageMetricToLabel[DailyAverageMetric.Sales],
    value: DailyAverageMetric.Sales
  },
  {
    label: DailyAverageMetricToLabel[DailyAverageMetric.CarCount],
    value: DailyAverageMetric.CarCount
  },
  {
    label: DailyAverageMetricToLabel[DailyAverageMetric.AverageTicket],
    value: DailyAverageMetric.AverageTicket
  }
]
